import { render, staticRenderFns } from "./settings-account.vue?vue&type=template&id=ae134b5c&scoped=true&"
import script from "./settings-account.vue?vue&type=script&lang=js&"
export * from "./settings-account.vue?vue&type=script&lang=js&"
import style0 from "./settings-account.vue?vue&type=style&index=0&id=ae134b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae134b5c",
  null
  
)

export default component.exports